import React, { useEffect } from 'react';
import TransportPageLayout from '../../components/transportation/TransportPageLayout';
import { ScheduleCard, TimesList, RatesTable } from '../../components/transportation/TransportUI';
import { setSeoMetadata } from '../../lib/seo';

const PassengerFerryPage = () => {
  useEffect(() => {
    setSeoMetadata({
      title: 'Passenger Ferry Schedule St John | St Thomas to St John | St John USVI',
      description:
        'Passenger ferry schedules and rates between St Thomas and St John: Red Hook / Cruz Bay, Crown Bay / Cruz Bay and Charlotte Amalie routes.',
      keywords: 'passenger ferry st john, red hook cruz bay ferry, charlotte amalie ferry st john, inter island boat services',
      canonicalPath: '/st-john-vi-passenger-ferry-information',
      ogType: 'website',
    });
  }, []);

  return (
    <TransportPageLayout title="Passenger Ferry Schedule" subtitle="St John, Virgin Islands" adId="passenger-ferry">
      <p className="text-center text-slate-700 leading-relaxed">
        Traveling between the islands of St. Thomas and St. John is easy on a ferry — there are three ferry routes
        available.
      </p>

      <ScheduleCard
        title="Red Hook, St Thomas ↔ Cruz Bay, St John"
        first
        testId="ferry-red-hook"
        operator={{
          operatedBy: 'Transportation Services and Varlack Ventures',
          phones: ['(340) 776-6282', '(340) 776-6412'],
          location: 'Cruz Bay Ferry Dock',
          travelTime: '15 minutes',
        }}
      >
        <div className="grid gap-6 sm:grid-cols-2">
          <TimesList label="Red Hook → Cruz Bay" times={['5:30 AM', '6:30 AM', '7:30 AM', '8:30 AM', '9:00 AM', '10:00 AM', '11:00 AM', 'Noon', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM', '10:00 PM', '11:00 PM', '11:30 PM']} />
          <TimesList label="Cruz Bay → Red Hook" times={['6:00 AM', '7:00 AM', '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM', 'Noon', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM', '10:00 PM', '11:00 PM']} />
        </div>
        <RatesTable rates={[['Non-Resident One-way', '$8.15'], ['Resident One-way', '$6.00'], ['Child (2-11) One-way', '$1.00'], ['Resident Senior One-way**', '$1.50'], ['Luggage/Box (each)', '$4.00']]} />
        <p className="text-xs text-slate-500">**Valid USVI ID required for resident rates.</p>
      </ScheduleCard>

      <ScheduleCard
        title="Crown Bay / Inter Island Ferry"
        subtitle="Crown Bay ↔ Cruz Bay"
        testId="ferry-crown-bay"
      >
        <div className="grid gap-6 sm:grid-cols-2">
          <TimesList label="Crown Bay → Cruz Bay" times={['8:30 AM*', '11:00 AM', '1:15 PM*', '4:15 PM (Fri/Sat/Sun*)']} />
          <TimesList label="Cruz Bay → Crown Bay" times={['9:45 AM*', '2:15 PM*', '3:30 PM', '5:30 PM (Fri/Sat/Sun*)']} />
        </div>
        <p className="text-xs text-slate-500">Check-in is 30 minutes prior to departure.</p>
        <RatesTable rates={[['Adult One-way', '$20.00'], ['Senior One-way', '$15.00'], ['Child (<12) One-way', '$10.00'], ['Luggage/Box (each)', '$5.00']]} />
      </ScheduleCard>

      <ScheduleCard
        title="Inter Island Boat Services"
        subtitle="Special trips to local festivities, carnivals, restaurants and bars"
        testId="ferry-inter-island"
        operator={{ operatedBy: 'Inter Island Boat Services', phones: ['(340) 776-6597'], location: 'Cruz Bay', travelTime: '30 minutes' }}
      >
        <p className="text-slate-700">Mon – Sun, 7:30am – 4:30pm.</p>
        <a
          href="https://www.interislandboatservices.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block font-bold uppercase tracking-wide text-blue-700 hover:underline"
          data-testid="ferry-inter-island-website"
        >
          Visit Our Website
        </a>
      </ScheduleCard>

      <ScheduleCard
        title="Charlotte Amalie Schedule"
        subtitle="Located in downtown Charlotte Amalie"
        testId="ferry-charlotte-amalie"
        operator={{
          operatedBy: 'Transportation Services and Varlack Ventures',
          phones: ['(340) 776-6282', '(340) 776-6412'],
          location: 'Charlotte Amalie Ferry Dock',
          travelTime: '15 minutes',
        }}
      >
        <div className="grid gap-6 sm:grid-cols-2">
          <TimesList label="Departing Charlotte Amalie" times={['10:00 AM', '3:00 PM', '5:30 PM']} />
          <TimesList label="Departing Cruz Bay" times={['8:45 AM', '11:15 PM', '3:45 PM']} />
        </div>
        <p className="text-xs text-slate-500">Check-in is 30 minutes prior to departure. Subject to seasonal change.</p>
        <RatesTable rates={[['Adult Non-Resident', '$13.00'], ['Resident One-way', '$12.00'], ['Senior One-way', '$6.00'], ['Child (<12) One-way', '$3.00'], ['Luggage/Box (each)', '$4.00']]} />
      </ScheduleCard>
    </TransportPageLayout>
  );
};

export default PassengerFerryPage;
